const aforoImageFallback = () => {
    document.querySelectorAll('img[data-image-fallback]').forEach((image) => {
        const showPlaceholder = () => {
            if (image.dataset.fallbackApplied === 'true') return;
            image.dataset.fallbackApplied = 'true';
            image.classList.add('is-placeholder');
            image.alt = 'Imagen no disponible';
            image.src = image.dataset.imageFallback;
        };

        image.addEventListener('error', showPlaceholder);
        if (image.getAttribute('src') === image.dataset.imageFallback) {
            showPlaceholder();
        } else if (image.complete && image.naturalWidth === 0) {
            showPlaceholder();
        }
    });
};

export default aforoImageFallback;
